import React, { Fragment, useEffect, useState, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import 'react-quill/dist/quill.snow.css';

import {
    getInboxService,
    getAllUserListService,
    createInboxGroupService,
    getChatHistoryService,
    getAllUserListForDirectorService,
} from '../../services/inboxService';
import { unreadCountAction } from '../../store/chat';
import {socket} from '../../services/socket';
import { debounce, SEARCH_DEBOUNCE_DELAY } from '../../helper';

import InboxMobile from './InboxMobile';
import ChatComponent from './ChatComponent';


const Inbox = props => {
    const chatScreen = document.getElementById('chat__screen');
    const scrollRef = useRef();
    let location                                           = useLocation();
    const [inputHeight, setInputHeight]                   = useState(0);
    const [users, setUsers]                               = useState([]);
    const [userSearch, setUserSearch]                     = useState('');
    const [userSearchInput, setUserSearchInput]           = useState('');
    const [userPageNo, setUserPageNo]                     = useState(1);
    const [createGroupModal, setCreateGroupModal]         = useState(false);
    const [createGroupstep, setCreateGroupstep]           = useState(1);
    const [newChatModal, setNewChatModal]                 = useState(false);
    const [inboxUser, setInboxUser]                       = useState([]);
    const [isSelected, setIsSelected]                     = useState(false);
    const [totalUserCount, setTotalUserCount]             = useState(0);
    const [singleUserId, setSingleUserId]                 = useState('');
    const [groupName, setGroupName]                       = useState('');
    const [groupImage, setGroupImage]                     = useState('');
    const [groupImageView, setGroupImageView]             = useState('');
    const [userId, setUserId]                             = useState([]);
    const [messages, setMessages]                         = useState([]);
    const [textMessage, setTextMessage]                   = useState('');
    const [newMessage, setNewMessage]                     = useState('');
    const [currentGroupId, setCurrentGroupId]             = useState('');
    const [currentChatUser, setCurrentChatUser]           = useState('');
    const [filterUser, setFilterUser]                     = useState('');
    const [filterUserInput, setFilterUserInput]           = useState('');
    const [msgLoader, setMsgLoader]                       = useState(false);
    const [lastMsgId, setLastMsgId]                       = useState('');
    const [msgCount, setMsgCount]                         = useState('');
    const [indexTab, setIndexTab]                         = useState(1);
    const [automationModal, setAutomationModal]           = useState(false);
    const [templateModal, setTemplateModal]               = useState(false);


    const messageEl                                       = useRef();
      const [isMobile, setIsMobile] = useState(window.innerWidth < 1399);

    
      // Resize handler - only update on breakpoint change
      const handleResize = useCallback(() => {
        const isNowMobile = window.innerWidth < 1399;
        // Only update if mobile state changed
        setIsMobile(prev => {
          if (prev !== isNowMobile) {
            return isNowMobile;
          }
          return prev;
        });
      }, []);
    
      // Attach debounced resize listener
      useEffect(() => {
        let frameId = null;
    
        const onResize = () => {
          if (frameId) return;
          frameId = requestAnimationFrame(() => {
            handleResize();
            frameId = null;
          });
        };
    
        window.addEventListener('resize', onResize);
        return () => {
          window.removeEventListener('resize', onResize);
          if (frameId) cancelAnimationFrame(frameId);
        };
      }, [handleResize]);




    useEffect(() => {
        socket.emit('join'); 
        setNewMessage('');
        socket.on('receiveMessage', data => {
            setNewMessage(data);
        });
    }, []);


    

    useEffect(() => {
        if(currentGroupId){
            socket.emit('join', currentGroupId);         
        }

    }, [currentGroupId])




    useEffect(() => {
        if(newMessage.senderId === currentChatUser.userId){
            setMessages([...messages, newMessage]);
            setTimeout(() => {
                messageEl.current.scroll({ top: messageEl.current.scrollHeight, behavior: 'smooth' })
            }, 100)
        }
    }, [newMessage])



    const getInbox = () => {
        let query = `?search=${filterUser}`
        getInboxService(query).then(res => {
            if(res?.data?.statusCode){
                setInboxUser(res.data.responseData.result)
                props.unreadCountAction()
            }
        })
    }

    useEffect(() => {
        getInbox()
    }, [filterUser])






    const getAllUserList = () => {
        
        if(props.userProfile.UserType === 1){
            let query = `?search=${userSearch}&pageNo=${userPageNo}&limit=10`;
            getAllUserListService(query).then(res => {
                if(res?.data?.statusCode){
                    setTotalUserCount(res.data.responseData.count)
                    if(userSearch){
                        setUsers(res.data.responseData.result)
                    }else{
                        setUsers([...users, ...res.data.responseData.result])
                    }
                    
                }
            })

        }else {
            let query = `?search=${userSearch}&pageNo=${userPageNo}&limit=10&campCode=${props.userProfile.campCode}`;
            getAllUserListForDirectorService(query).then(res => {
                if(res?.data?.statusCode){
                    setTotalUserCount(res.data.responseData.count)
                    if(userSearch){
                        setUsers(res.data.responseData.result)
                    }else{
                        setUsers([...users, ...res.data.responseData.result])
                    }
                    
                }
            })
        }  
    }

    useEffect(() => {
        getAllUserList()
    }, [userSearch, userPageNo])


    const handleMsgChange = e => {
        setTextMessage(e.target.value)
        setInputHeight((e.target.value.match(/\n/g)||[]).length)
    }

    const toggleMsgSidebar = () => document.body.classList.toggle('toogle_msg_sider');


    const debouncedUserSearch = useCallback(debounce(value => { setUserSearch(value); setUserPageNo(1); }, SEARCH_DEBOUNCE_DELAY), []);
    const debouncedFilterUser = useCallback(debounce(value => setFilterUser(value), SEARCH_DEBOUNCE_DELAY), []);

    const handleUserSerach = e => {
        setUserSearchInput(e.target.value);
        debouncedUserSearch(e.target.value);
    }


    const handleLoadMore = () => {
        setUserPageNo(userPageNo + 1);
    }

    const closeModal = () => {
        setCreateGroupModal(false);
        setNewChatModal(false);
        setCreateGroupstep(1);
        setUserSearch('');
        setUserSearchInput('');
        setUserPageNo(1);
        setAutomationModal(false);
        setTemplateModal(false);
    }



    useEffect(() => {
        if(props.bookingUserChat){
            handleSingleUserId(props.bookingUserChat)
        }

    }, [props.bookingUserChat])

    const sendMessage = () => {
        chatScreen.scrollTop = chatScreen.scrollHeight;
        if(textMessage.trim() !== ''){

            setMessages([...messages, {
                message: textMessage,
                senderId: props.userProfile._id,
                timeStamp: new Date().getTime()
            }]); 

            setTimeout(() => {
                messageEl.current.scroll({ top: messageEl.current.scrollHeight, behavior: 'smooth' })
            }, 100)

            let tempMsg = {
                'groupId': currentChatUser.groupId,
                'receiverId': currentChatUser.userId,
                'senderId': props.userProfile._id,
                'message': textMessage,
                'timeStamp': new Date().getTime()
            }

            socket.emit('sendMessage', tempMsg);

            setTextMessage('');
            getInbox();

        }
    }





    const handleSingleUserId = user => {
        setCurrentChatUser(user);
        setSingleUserId(user._id)
        closeModal();
        setIsSelected(true);
        getMessagesDirect(user);
    }

    useEffect(() => {
        if(location.user){
            handleSingleUserId(location.user);
        } 
    }, [])

    const getMessagesDirect = (user) =>{
        setCurrentChatUser({
            name: user.name
        })
        setIsSelected(true);
        toggleMsgSidebar();
            let query = '';
            if(user.type===1)
            {
                query = `/?type=1&receiverId=${user._id}&limit=15`;
            }
            else
            {
                query = `/?type=2&groupId=${user._id}&limit=15`;
            }
            getChatHistoryService(query).then(res => {
            setMsgLoader(false);
            if(res?.data?.statusCode){
                setLastMsgId(res.data.responseData.result.length ? res.data.responseData.result[res.data.responseData.result.length - 1].chatId : '');
                setMessages(res.data.responseData.result.reverse());
            }
        })
    }

    const createGroup = () => {
        let params = new FormData();
        params.append('groupName',groupName);
        params.append('groupImage',groupImage);
        params.append('userId',JSON.stringify([...userId, props.userProfile._id]));
        params.append('type','2');

        createInboxGroupService(params).then(res => {
          if(res?.data?.statusCode){
            closeModal();
            getInbox();
          }
        })  
    }

    const handleFileChange = e => {
        let reader = new FileReader();
        let file = e.target.files[0];
        setGroupImage(file);
        
        reader.addEventListener('load', () => {
            setGroupImageView(reader.result);
        }, false);
        if (file) { reader.readAsDataURL(file) }
    }

    const addUserInGroup = e => {
        if(userId.includes(e.target.value)){
            let tempArr = userId.filter(item => item !== e.target.value);
            setUserId(tempArr);
        }else{
            setUserId([...userId, e.target.value])
        }
    }

    

    const getMessages = user => {
        setMsgLoader(true);
        if(user.type === 1){
            setCurrentChatUser({
                ...user,
                name: user.userId[0].name,
                userId: user.userId[0]._id,
                profileImage: user.userId[0].profileImage
            })
        }else{
            setCurrentChatUser({
                name: user.groupName,
                profileImage: user.groupImage
            })
        }
        
        setIsSelected(true);
        setCurrentGroupId(user.groupId);
        toggleMsgSidebar();
            let query = `/?groupId=${user.groupId}&receiverId=${''}&limit=15`;
            getChatHistoryService(query).then(res => {
                setMsgLoader(false);
                if(res?.data?.statusCode){
                    setLastMsgId(res.data.responseData.result.length ? res.data.responseData.result[res.data.responseData.result.length - 1].chatId : '');
                    setMessages(res.data.responseData.result.reverse());
                    chatScreen.scrollTop = chatScreen.scrollHeight;
                    props.unreadCountAction();
                    getInbox();
                }
        })
    }




        
      const handleScroll = e => {
        let chatScroll = document.getElementById('chat__screen');
          if(chatScroll.scrollTop < 1 && msgCount !== 0){
            setMsgLoader(true);
            let query = `/?lastMsgId=${lastMsgId}&groupId=${currentGroupId}&receiverId=${''}&limit=15`;
            getChatHistoryService(query).then(res => {
                setMsgLoader(false);
                if(res?.data?.statusCode){
                    setMsgCount(res.data.responseData.count);
                    setLastMsgId(res.data.responseData.result.length ? res.data.responseData.result[res.data.responseData.result.length - 1].chatId : '');
                    let oldMsg = res.data.responseData.result.reverse();
                    setMessages([...oldMsg, ...messages]);
                }
            })
          }  
      };




    return(
        <div className="body_container cm_over_auto pb-4" style={{backgroundColor: '#F7F7F7'}}>
            <div className="container">
                <div className="d-flex align-items-center justify-content-between page_card_header">
                    <h4>Inbox</h4>
                    <div className="btn_group">
                        <button className="btn btn-outline-primary btn-sm rounded-0" onClick={() => setNewChatModal(true)}><i className="icon-create" /> New Message</button>
                        <button className="btn btn-secondary ms-3 btn-sm rounded-0" onClick={() => setCreateGroupModal(true)}><i className="icon-users" /> Organize Group</button>
                    </div>
                </div>
            <div className="page_card pb-0">


                {
                    isMobile? 
                            <InboxMobile
                                inboxUser={inboxUser}
                                filterUser={filterUserInput}
                                setFilterUser={value => { setFilterUserInput(value); debouncedFilterUser(value); }}
                                getMessages={getMessages}
                                isSelected={isSelected}
                                currentChatUser={currentChatUser}
                                messageEl={messageEl}
                                handleScroll={handleScroll}
                                messages={messages}
                                msgLoader={msgLoader}
                                userProfile={props.userProfile}
                                inputHeight={inputHeight}
                                handleMsgChange={handleMsgChange}
                                sendMessage={sendMessage}
                                textMessage={textMessage}
                            /> : <ChatComponent
                                inboxUser={inboxUser}
                                filterUser={filterUserInput}
                                setFilterUser={value => { setFilterUserInput(value); debouncedFilterUser(value); }}
                                getMessages={getMessages}
                                isSelected={isSelected}
                                currentChatUser={currentChatUser}
                                messageEl={messageEl}
                                handleScroll={handleScroll}
                                messages={messages}
                                msgLoader={msgLoader}
                                userProfile={props.userProfile}
                                inputHeight={inputHeight}
                                handleMsgChange={handleMsgChange}
                                sendMessage={sendMessage}
                                textMessage={textMessage}
                            />
                }
                 </div>


            <Modal
                size="lg"
                show={newChatModal}
                dialogClassName="remove_header_line"
                animation={false}
                centered>

                <Modal.Header>
                    <Modal.Title>New Chat</Modal.Title>
                    <span className="modal_close" onClick={closeModal}><i className="icon-cross" /></span>
                </Modal.Header>

                <Modal.Body>
                
                    <div className="search_wrapper">
                        <i className="icon-search" />
                        <input
                            type="text"
                            value={userSearchInput}
                            onChange={handleUserSerach}
                            placeholder="Search" />
                    </div>
                    
                    <div className="user_list single_user">
                        <ul>
                            {
                                users.length ? users.filter(item => item._id !== props.userProfile._id).map(user => (
                                    <li key={user._id} onClick={() => handleSingleUserId(user)}>
                                        <img src={user.profileImage ? user.profileImage : require("../../assets/img/user.png")} />
                                        <p>{user.name ? user.name : user.email}</p>
                                        {/* {user.UserType === 2 ? <small className='ms-2'> Camp Director</small> : ''} */}
                                    </li>
                                )) : ''
                            }
                        </ul>

                        {
                            (totalUserCount === users.length || (totalUserCount - users.length) > 0) ? 
                            <div className="text-center position-relative mt-4">
                                <button onClick={handleLoadMore} className="btn btn-primary btn-sm">Load more</button>
                                <div className="remain_user">{totalUserCount - users.length} more users</div>
                            </div> : ''
                        }
                        
                    </div>

                </Modal.Body>
            </Modal>


            <Modal
                size="lg"
                show={createGroupModal}
                dialogClassName="remove_header_line"
                animation={false}
                centered>

                <Modal.Header>
                    <Modal.Title>Create Group</Modal.Title>
                    <span className="modal_close" onClick={closeModal}><i className="icon-cross" /></span>
                </Modal.Header>

                <Modal.Body>
                
                {
                    (createGroupstep === 1) ? <Fragment>
                        <div className="search_wrapper">
                            <i className="icon-search" />
                            <input
                                type="text"
                                value={userSearchInput}
                                onChange={handleUserSerach}
                                placeholder="Search" />
                        </div>
                        
                        <div className="user_list">
                            <ul>
                                {
                                    users.length ? users.map(user => (
                                        <li key={user._id}>
                                            <img src={user.profileImage ? user.profileImage : require("../../assets/img/user.png")} />
                                            <p>{user.name}</p>
                                            <div className="check_box_wrapper cm_dark_check pt-1">
                                            <input type="checkbox" value={user._id} checked={userId.includes(user._id)} onChange={addUserInGroup} />
                                                <span className="check_box"><span></span></span>
                                            </div>
                                        </li>
                                    )) : ''
                                }  
                            </ul>

                            {
                                (totalUserCount === users.length || (totalUserCount - users.length) > 0) ? 
                                <div className="text-center position-relative mt-4">
                                    <button onClick={handleLoadMore} className="btn btn-primary btn-sm">Load more</button>
                                    <div className="remain_user">{totalUserCount - users.length} more users</div>
                                </div> : ''
                            }
                        </div>
                    </Fragment>
                    
                    :

                    <Fragment>
                        <div className="icon_upload_wrapper" style={{width: '100%'}}>
                            <input type="file" onChange={handleFileChange} accept="image/x-png,image/jpeg,image/webp,image/avif, .webm, .avif"/>
                            {groupImageView ? <img src={groupImageView} alt=''/> : ''}

                            {groupImageView ? <i className="icon-create" /> : <div>
                                                                                <i className="icon-upload-cercle" />
                                                                                <p>Upload Image</p>
                                                                            </div>}
                            
                        </div>

                        <div className="group_name">
                            <input
                                type="text"
                                value={groupName}
                                onChange={e => setGroupName(e.target.value)}
                                placeholder="Group name" />
                        </div>

                    </Fragment>
                }



                    <div className="d-flex justify-content-center">
                        <button onClick={closeModal} className="btn btn-light me-4 ps-5 pe-5">Cancel</button>
                        {
                            createGroupstep === 1 ?
                            <button disabled={userId.length ? false : true} onClick={() => setCreateGroupstep(2)} className="btn btn-primary ps-5 pe-5">Next</button>:
                            <button disabled={groupName !== '' ? false : true} onClick={createGroup} className="btn btn-primary ps-5 pe-5">Done</button>
                        }
                    </div>


                </Modal.Body>
            </Modal>


        </div>
        </div>
    )
}


const mapStateToProps = state => {
    let { userProfile } = state.user;
    let { bookingUserChat } = state.chat;
    return {
        userProfile,
        bookingUserChat,
    };
}
  
const mapDispatchToProps = dispatch => ({
    unreadCountAction: () => dispatch(unreadCountAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Inbox);